import type { OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ng-notification',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './notification.component.html',
})
export class NotificationComponent implements OnInit {
    @Input() public title: string;
    @Input() public message: string;
    @Input() public duration?: number = 5000; // set 0 to disable timeout
    @Input() public type?: 'info' | 'success' | 'warning' | 'danger' | 'primary' = 'primary';
    @Input() public icon?: string;

    @Output() onRemove = new EventEmitter<void>();

    ngOnInit(): void {
        if (this.duration > 0) {
            setTimeout(() => {
                this.onRemove.emit();
            }, this.duration);
        }
    }

    remove(): void {
        this.onRemove.emit();
    }
}
